export const PANEL_GAP_PX = 4;
export const PANEL_VIEWPORT_MARGIN_PX = 8;

/**
 * Prefers below the anchor, flips above when there is room, and otherwise shifts
 * the panel up so its bottom (e.g. lesson and meeting links) stays in the viewport.
 */
export function computePanelTop(
  anchorRect: { top: number; bottom: number },
  panelHeight: number,
  viewportHeight: number,
): number {
  const maxBottom = viewportHeight - PANEL_VIEWPORT_MARGIN_PX;
  const topBelow = anchorRect.bottom + PANEL_GAP_PX;
  if (panelHeight <= 0 || topBelow + panelHeight <= maxBottom) {
    return topBelow;
  }
  const topAbove = anchorRect.top - panelHeight - PANEL_GAP_PX;
  if (topAbove >= PANEL_VIEWPORT_MARGIN_PX) {
    return topAbove;
  }
  return Math.max(PANEL_VIEWPORT_MARGIN_PX, maxBottom - panelHeight);
}
